<template>
  <div class="d-show-out-screen">
    <div ref="originalContent">
      <slot name="content" />
    </div>

    <div
      ref="duplicateContent"
      class="duplicate-content"
      :class="{ 'shown': isShown }"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import SASS from '@dui/helpers/sass';

const ELEMENT_OFFSET = 32;

export default {
  props: {
    after: {
      type: String,
      required: true,
    },
    until: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    elements: {
      afterEl: null,
      untilEl: null,
    },
    isShown: false,
  }),
  beforeDestroy() {
    this.removeEventListeners();
  },
  mounted() {
    this.configure();
  },
  methods: {
    addEventListeners() {
      window.addEventListener('scroll', this.windowScrollPerformed);
    },

    calculateAndShow() {
      this.$refs.duplicateContent.style.top = null;

      const duplicateElRects = this.$refs.duplicateContent.getClientRects()[0];

      const afterRects = this.elements.afterEl.getClientRects()[0];
      const isAfterElOffScreen = (window.innerHeight - (afterRects.top + afterRects.height)) > (duplicateElRects.height + ELEMENT_OFFSET);
      if (!isAfterElOffScreen) {
        return false;
      }

      const untilRects = this.elements.untilEl.getClientRects()[0];
      const isUntilElReached = (duplicateElRects.top + duplicateElRects.height) > (untilRects.top - ELEMENT_OFFSET);
      if (isUntilElReached) {
        const elBottom = `${ untilRects.top - duplicateElRects.height - ELEMENT_OFFSET }px`;
        this.$refs.duplicateContent.style.top = elBottom;
      }

      return true;
    },

    async configure() {
      await this.$nextTick();

      if (window.innerWidth < SASS.screenSize.md) {
        this.$refs.duplicateContent.remove();
        return;
      }

      this.elements.afterEl = document.getElementById(this.after);
      this.elements.untilEl = document.getElementById(this.until);

      if (!this.elements.afterEl || !this.elements.untilEl) {
        return;
      }

      this.addEventListeners();
      this.windowScrollPerformed();
    },

    removeEventListeners() {
      window.removeEventListener('scroll', this.windowScrollPerformed);
    },

    setDuplicateSize() {
      const originalContentElBoundingRects = this.$refs.originalContent.getClientRects()[0];
      this.$refs.duplicateContent.style.width = `${ originalContentElBoundingRects.width }px`;
    },

    windowScrollPerformed() {
      this.setDuplicateSize();

      const isShown = this.calculateAndShow();
      if (this.isShown === isShown) {
        return;
      }

      this.isShown = isShown;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-show-out-screen {
  .duplicate-content {
    bottom: $_4em;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    right: $_6em;
    z-index: 1;

    @include screenMoreThan(md) {
      right: calc(50% - 480px);
    }

    @include transition((
      opacity
    ));

    &.shown {
      opacity: 1;

      // pointer-events should be placed to the content to prevent overlapping next nodes by .duplicate-content block
      & > * {
        pointer-events: all;
      }
    }
  }
}
</style>
